import React from 'react';
import isEmpty from 'lodash/isEmpty';
import kebabCase from 'lodash/kebabCase';
import PropTypes from 'prop-types';
import classNames from '~/components/util/classNames';
import ReactSelect from 'react-select';

function FormSelect(props) {
    const { label = '' } = props;

    const {
        className = '',
        inputClassName = '',
        defaultValue = null,
        error = '',
        groupClassName = '',
        labelClassName = '',
        hideLabel,
        index,
        isClearable = false,
        isMulti = false,
        isSearchable = false,
        closeOnSelect = true, 
        name = kebabCase(label),
        onChange,
        options = [],
        path = '',
        placeholder = null,
        readOnly = false,
        required,
        smallText = '',
        value = ''
    } = props;


    const hasError = !isEmpty(error);
    const hasErrorClass = hasError ? 'is-invalid' : '';
    const inputClasses = classNames('form-input', hasErrorClass, className, inputClassName);
    const labelClasses = classNames('form-label', labelClassName);
    
    return (
        <div className={classNames('react-select-control form-group', groupClassName, hasError && 'is-invalid')}>
            { 
                !hideLabel &&
                <label htmlFor={name} className={labelClasses} dangerouslySetInnerHTML={{__html: label}}></label>
            }
            <ReactSelect
                id={name}
                name={name}
                className={inputClasses}
                placeholder={placeholder}
                defaultValue={defaultValue}
                value={value}
                isDisabled={readOnly}
                key={index}
                onChange={value => onChange(value, path, index)}
                options={options}
                required={required}
                isClearable={isClearable}
                isSearchable={isSearchable}
                isMulti={isMulti}
                closeMenuOnSelect={closeOnSelect}
            />
            {(smallText && !hasError) &&
                <small className="form-text text-muted">{smallText}</small>
            }
            <div className="invalid-feedback">{error}</div>
        </div>
    );
}

FormSelect.propTypes = {
    classes: PropTypes.string,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    defaultValue: PropTypes.object,
    error: PropTypes.string,
    groupClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    hideLabel: PropTypes.bool,
    index: PropTypes.number,
    isClearable: PropTypes.bool,
    isMulti: PropTypes.bool,
    isSearchable: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onInputChange: PropTypes.func,
    options: PropTypes.array,
    path: PropTypes.string,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    smallText: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    closeOnSelect: PropTypes.bool
};

export default FormSelect;
